const BAR_COUNT = 14;

export function ChartSkeleton() {
    return (
        <div className="flex items-end gap-2 h-full px-1">
            {Array.from({ length: BAR_COUNT }).map((_, i) => (
                <div
                    key={i}
                    className="flex-1 rounded-t bg-gray-100 animate-pulse"
                    style={{ height: `${30 + ((i * 13) % 60)}%` }}
                />
            ))}
        </div>
    );
}
